export class IssueCustomerMessage {
  customerNumber: string;
  id: string;
  issueId: string;
  messageDisplayType: string;
  messageText: string;
  startDate: any;
  endDate: any;
  links: any;
  siteId: string;
  siteNumber: string;
}
